module.exports = __webpack_public_path__ + "img/TRI.dd2997eb.svg";